import { CircleMinus, Minus } from 'lucide-react';
import { DeckardIconWrapper } from './DeckardIcon';

export const RemoveIcon = DeckardIconWrapper({ Icon: Minus, CircleIcon: CircleMinus });
